import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DialogLayoutService implements OnDestroy {
    forceColumn: Subject<boolean>;
    forceColumnAtWidth: number;
    private _parentEl: HTMLElement;
    private readonly _observer: ResizeObserver;

    constructor() {
        this.forceColumnAtWidth = 900;
        this.forceColumn = new Subject();

        this._observer = new window.ResizeObserver((resizeObserverEntries) => {
            this.forceColumn.next(
                resizeObserverEntries[0].contentRect.width <
                    this.forceColumnAtWidth,
            );
        });
    }

    ngOnDestroy(): void {
        this.forceColumn.complete();
        this._observer.disconnect();
    }

    observeParent(el: HTMLElement): void {
        if (this._parentEl != null) {
            this._observer.unobserve(this._parentEl);
        }

        this._parentEl = el;
        this._observer.observe(el);
    }
}
